import React from "react";
import { WifiOff, Download, Share } from "lucide-react";
import { usePWA } from "../hooks/usePWA";

// Global PWA UI: offline banner + persistent install prompt (stays until installed)
export default function PWAControls() {
  const { online, installed, canInstall, isIOS, promptInstall } = usePWA();
  const [showIosHelp, setShowIosHelp] = React.useState(false);
  const [raceActive, setRaceActive] = React.useState(false);

  React.useEffect(() => {
    const check = () => { try { setRaceActive(!!localStorage.getItem("supera_race_active")); } catch {} };
    check();
    const id = setInterval(check, 1500);
    window.addEventListener("supera-race-update", check);
    window.addEventListener("storage", check);
    return () => { clearInterval(id); window.removeEventListener("supera-race-update", check); window.removeEventListener("storage", check); };
  }, []);

  return (
    <>
      {!online && (
        <div className="fixed top-0 inset-x-0 z-[60] bg-[#0A1C30] text-white text-sm font-semibold py-2 px-4 flex items-center justify-center gap-2">
          <WifiOff className="w-4 h-4 text-gold" />
          Sin conexión — estás viendo SUPERA en modo offline.
        </div>
      )}

      {!installed && !raceActive && (
        <div className="fixed bottom-5 left-5 z-[60] max-w-xs animate-fade-up" data-testid="install-banner">
          <div className="flex items-start gap-3 bg-white rounded-2xl shadow-2xl ring-1 ring-black/10 p-3.5">
            <span className="flex-shrink-0 w-11 h-11 rounded-xl bg-[#0A1C30] flex items-center justify-center">
              <Download className="w-5 h-5 text-gold" />
            </span>
            <div className="flex-1">
              <p className="text-sm font-extrabold text-[#0A1C30] leading-tight">Instala SUPERA</p>
              {canInstall ? (
                <button
                  data-testid="install-add-btn"
                  onClick={promptInstall}
                  className="mt-1 text-xs font-bold text-[#E9A400] hover:underline"
                >
                  Añadir a la pantalla de inicio
                </button>
              ) : isIOS ? (
                <>
                  <button
                    data-testid="install-ios-btn"
                    onClick={() => setShowIosHelp((v) => !v)}
                    className="mt-1 text-xs font-bold text-[#E9A400] hover:underline"
                  >
                    Añadir a la pantalla de inicio
                  </button>
                  {showIosHelp && (
                    <p className="mt-1.5 text-xs text-[#6B7688] leading-snug">
                      Toca <Share className="inline w-3.5 h-3.5 -mt-0.5" /> <b>Compartir</b> y luego{" "}
                      <b>“Añadir a pantalla de inicio”</b>.
                    </p>
                  )}
                </>
              ) : (
                <>
                  <button
                    data-testid="install-help-btn"
                    onClick={() => setShowIosHelp((v) => !v)}
                    className="mt-1 text-xs font-bold text-[#E9A400] hover:underline"
                  >
                    Añadir a la pantalla de inicio
                  </button>
                  {showIosHelp && (
                    <p className="mt-1.5 text-xs text-[#6B7688] leading-snug">
                      En tu tablet o teléfono, abre el menú <b>⋮</b> del navegador (Chrome/Edge) y elige{" "}
                      <b>“Instalar app”</b> o <b>“Añadir a pantalla de inicio”</b>.
                    </p>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
